import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import HomeMap from '../../components/HomeMap';
import HomeCard from '../../components/HomeCard';
import { colors } from '../../styles';

const styles = css`
  .Homes_homesResults {
    position: relative;
    @media (min-width: 992px) {
      display: flex;
      flex-flow:row wrap;
      justify-content: flex-start;
    }
  }
  .Homes_mapWrapper {
    width: 100%;
    position: absolute;
    min-height:300px;
    z-index: 1;
    @media (min-width: 992px) {
      position:relative;
      width: calc(100% - 360px)
    }
    @media (min-width: 1500px) {
      width: calc(100% - 760px);
    }
  }
  .Homes_homesList--hide .Homes_mapWrapper {
    position:relative;
    height:300px;
    @media (min-width: 992px) {
      display:none;
    }
  }
  .Homes_homesList {
    height:auto;
    position: relative;
    z-index: 2;
    width: 100%;
    background-color: ${colors.white};
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-content: flex-start;
    @media (min-width: 992px) {
      height: 600px;
      width: 360px;
      overflow-y: scroll;
    }
    @media (min-width: 1500px) {
      width: 760px;
    }
  }
  .Homes_homesList--hide .Homes_homesList {
      display:none;
    @media (min-width: 992px) {
      display:flex;
      position:relative;
      width:100%;
      height:auto;
    }
  }
  .HomeResults_count {
    font-weight: 400;
    padding:15px 0;
    color: ${colors.body};
    text-align: center;
    width: 100%;
  }
  .HomeResults_countValue {
    display: inline-block;
    background-color: ${colors.neutral};
    color: ${colors.body};
    width: 30px;
    height: 30px;
    line-height: 28px;
    border-radius: 50%;
    text-align: center;
    margin: 0 5px 0 0;
  }
`;


function HomesResults({ homes, sort, showMap }) {
  return (
    <div className={styles}>
      <div className={`Homes_homesResults ${showMap ? 'Homes_homesList--hide' : ''}`}>
        <div className="Homes_mapWrapper">
          <HomeMap />
        </div>
        <div className="Homes_homesList">
          <div className="HomeResults_count">
            <span className="HomeResults_countValue">{homes.length} </span>
            Homes
          </div>
          {
            orderBy(homes, sort.field, get(sort, 'dir', 'asc')).map(home => (
              <HomeCard key={home._id} home={home} />
            ))
          }
        </div>
      </div>
    </div>
  );
}

HomesResults.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object,
  showMap: PropTypes.bool.isRequired,
};

HomesResults.defaultProps = {
  activeMapPin: undefined,
  sort: { title: 'Price', field: 'price' },
};

export default withData(
  {
    activeMapPin: true,
    homes: true,
  },
  {
    required: {
      homes: true,
    },
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/Homes/HomesResults.js